YP.NavHover = function() {
    var item    = $(".nav_header .item_profil");

    return {
        init: function() {
            item.on("click",    this.ShowOrga);
            $('#js-topnav--toggle').on("click", function(e) {
                e.preventDefault();
                $('.c-dashboard-left-panel').toggleClass('is-active');
                $(this).toggleClass('is-active');
            })
        },
        ShowOrga: function(e){
            if($(this).hasClass('orga_visible')){
                $(this).removeClass('orga_visible');
            }
            else{
                $(this).addClass('orga_visible');
            }
        }
    };
}

window.addEventListener("load", function(){
    if($('.c-dashboard-left-panel').length > 0) {
      YP.NavHover().init();
    }
});
